import clsx from 'clsx';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext';

import { ChevronDown, Loader, Logo } from '../../atoms'
import { Corporate, CorporateUsers } from '../../types/types'
import { StartupStartMatchReq } from 'components/types/Api';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import useMediaQuery from 'hook/useMediaQuery';
import { MediaMobile, MediaTablet } from 'api/const/MediaQuery';

interface iTableBody {
  data: Corporate[];
  isLoading: boolean;
  askForaMatch: (userId: string, companyName: string, userName: string, companyId: string) => void
  selectedId?: string
  setSelectedId?: (selectedId: string) => void
}

export const TableBody = ({ data, isLoading, askForaMatch, selectedId, setSelectedId }: iTableBody) => {
  const { startUp, numberMatchRequest } = useContext(AppGeneralContext)
  const [tooltipIsOpen, setTooltipIsOpen] = useState<boolean>(false)
  const tablet = useMediaQuery(MediaTablet)
  const mobile = useMediaQuery(MediaMobile)

  const openRow = (id: string) => {
    if (id === selectedId) {
      return setSelectedId?.("")
    }

    return setSelectedId?.(id)
  }

  const cannotAskForMatch = useCallback(
    (user: CorporateUsers, isTablet: boolean) => {

      const unmatchableReason = user.unmatchableReason ?? (numberMatchRequest < 1 ? "0 Ask for a Match available" : "")

      return (
        <div className={`d-flex justify-content-end actions logoContainer align-items-center pe-2 link-disabled ${isTablet ? 'w-100' : ''}`}
          onMouseEnter={() => setTooltipIsOpen(true)}
          onMouseLeave={() => setTooltipIsOpen(false)}>
          <OverlayTrigger
            trigger={['click', 'hover', 'focus']}
            show={tooltipIsOpen}
            delay={{ hide: 200, show: 200 }}
            overlay={(props) => (
              <Tooltip {...props} >
                <span>{unmatchableReason}</span>
              </Tooltip>
            )}
            placement='top'>

            <div className={`m-0 p-0 text-uppercase ${isTablet ? 'w-100 tac' : ''}`}
              onClick={() => { }}>
              <Logo className='tableLogo' />
              ask for a match
            </div>
          </OverlayTrigger>
        </div>
      )
    },
    [numberMatchRequest, tooltipIsOpen]
  )

  const askForMatch = (user: CorporateUsers, company: Corporate) => {
    return (
      <>
        <Logo className='tableLogo' />
        <div className='text-uppercase '
          onClick={() => askForaMatch(user.value, company.name, user.label, company.id)}>
          ask for a match
        </div>
      </>
    )
  }

  const showBody = useMemo(() => {

    if (tablet) {
      return (
        data.map((company) => {
          return (
            <div key={company.id} className=' d-flex tableBody flex-column'>
              <div className="d-flex flex-row ps-3 pe-3 justify-content-between align-items-center w-100 ">
                <div className={clsx('d-flex  pb-3 pt-3 flex-column align-items-startjustify-content-between',
                  { "w-75": !mobile },
                  { "w-100": mobile }
                )} id={company.id}>
                  <p className="tm-col  w-100 "><b>Corporate:</b> {company.name}</p>
                  <p className="tm-col w-100"><b>N°Contacts:</b> {company?.countUserCompany}</p>
                  {mobile &&
                    <p
                      className={selectedId === company.id ? 'close-accordion tm-col w-100' : 'actions tm-col w-100'}
                      onClick={() => { openRow(company.id) }}>
                      {selectedId === company.id ? 'Close' : 'Discover'}
                      <ChevronDown className='openRow' />
                    </p>
                  }
                </div>
                {!mobile &&
                  <div className="actions">
                    <div className={selectedId === company.id ? 'close-accordion' : ''}
                      onClick={() => { openRow(company.id) }}>
                      {selectedId === company.id ? 'Close' : 'Discover'} <ChevronDown className='openRow' />
                    </div>
                  </div>}
              </div>
              {selectedId === company.id &&
                <div className=' bg-white pt-3 pb-3'>
                  <div className='d-flex justify-content-between innerTableHead ' >
                    {!mobile &&
                      <>
                        <div className='innerTh Hcorporates ps-3'>Department</div>
                        <div className='innerTh Hcorporates ps-3'>Level</div>
                        <div className='innerThR' >Actions</div>
                      </>
                    }
                  </div>
                  {company.users?.map((user) => {
                    return (
                      <div className={clsx('d-flex justify-content-between align-items-center tablePadding innerTr',
                        { "flex-row": !mobile },
                        { "flex-column": mobile })}
                        key={company.id + user.value + "body"}>
                        <div className={clsx(' text-capitalize ',
                          { "Hcorporates ps-3": !mobile },
                          { "w-100 tac ": mobile }
                        )} >Department: <b>{user?.label}</b></div>
                        <div className={clsx(' text-capitalize pb-3',
                          { "Hcorporates ps-3": !mobile },
                          { "w-100 tac ": mobile }
                        )} >Level: <b>{user?.level}</b></div>
                        {user.canMatch && numberMatchRequest > 0 ?
                          <div className={clsx('m-0 p-0 d-flex  justify-content-end actions  align-items-center pe-2',
                            { "justify-content-end logoContainer": !mobile },
                            { "justify-content-center pt-3  w-100": mobile })} >
                            {askForMatch(user, company)}
                          </div>
                          :
                          cannotAskForMatch(user, true)
                        }
                      </div>
                    )
                  })}

                </div>
              }
            </div>
          )
        })
      )
    } else {
      return (
        data.map((company) => {
          return (
            <div key={company.id} className='d-flex tableBody flex-column'>
              <div className='d-flex  pb-3 pt-3  justify-content-between' id={company.id}>
                <div className="t-col corporates ps-3 ">{company.name}</div>
                <div className="t-col Ncontact ">{company?.countUserCompany}</div>
                <div className=" t-col actions ">
                  <div className={selectedId === company.id ? 'close-accordion' : ''}
                    onClick={() => { openRow(company.id) }}>
                    {selectedId === company.id ? 'Close' : 'Discover'} <ChevronDown className='openRow' />
                  </div>
                </div>
              </div>
              {selectedId === company.id &&
                <div className=' bg-white pt-3 pb-3'>
                  <div className='d-flex justify-content-between innerTableHead ' >
                    <div className='innerTh Hcorporates ps-3 ' >Department</div>
                    <div className='innerTh Hcorporates text-center p-0 m-0  '>Level</div>
                    <div className='innerTh Hcorporates text-center ps-3 ' >Actions</div>
                  </div>
                  {company.users?.map((user) => {
                    return (
                      <div className={'d-flex justify-content-between align-items-center tablePadding innerTr '} key={company.id + user.value + "body"}>
                        <div className='Hcorporates text-capitalize ps-3 ' >{user?.label}</div>
                        <div className='Hcorporates text-center ms-4 text-capitalize  ' >{user?.level}</div>
                        {user.canMatch && numberMatchRequest > 0 ?
                          <div className='d-flex p-0 m-0 justify-content-end actions Hcorporates logoContainer align-items-center pe-2 ' >
                            {askForMatch(user, company)}
                          </div>
                          :
                          cannotAskForMatch(user, false)
                        }
                      </div>
                    )
                  })}

                </div>
              }
            </div>
          )
        })
      )
    }


  }, [selectedId, numberMatchRequest, isLoading, tablet, mobile, cannotAskForMatch])




  return (
    <>
      {showBody}
    </>

  )
}
